import { apolloClient } from '@/plugins/apollo';
import {
  AdminReviewActivity,
  AdminUserActivity,
  AdminReviewActivityDetail,
  AdminUserActivityDetail,
} from '@/graphql';

export default {
  namespaced: true,
  state: () => ({ window: 'DAYS_90', reviews: [], users: [] }),
  mutations: {
    setWindow(state, window) {
      state.window = window;
    },
    setReviews(state, reviews) {
      state.reviews = reviews;
    },
    setUsers(state, users) {
      state.users = users;
    },
  },
  actions: {
    async fetchReviewActivity(
      { commit, state },
      { includeArchived = false } = {}
    ) {
      const { data } = await apolloClient.query({
        query: AdminReviewActivity,
        variables: { window: state.window, includeArchived },
        fetchPolicy: 'network-only',
      });
      commit('setReviews', data.adminReviewActivity);
      return data.adminReviewActivity;
    },
    async fetchUserActivity({ commit, state }) {
      const { data } = await apolloClient.query({
        query: AdminUserActivity,
        variables: { window: state.window },
        fetchPolicy: 'network-only',
      });
      commit('setUsers', data.adminUserActivity);
      return data.adminUserActivity;
    },
    async fetchReviewDetail({ state }, reviewId) {
      const { data } = await apolloClient.query({
        query: AdminReviewActivityDetail,
        variables: { reviewId, window: state.window },
        fetchPolicy: 'network-only',
      });
      return data.adminReviewActivityDetail;
    },
    async fetchUserDetail({ state }, researcherId) {
      const { data } = await apolloClient.query({
        query: AdminUserActivityDetail,
        variables: { researcherId, window: state.window },
        fetchPolicy: 'network-only',
      });
      return data.adminUserActivityDetail;
    },
  },
};
